import { render, staticRenderFns } from "./FolderThumbList.vue?vue&type=template&id=328f5a34&scoped=true&"
import script from "./FolderThumbList.vue?vue&type=script&lang=js&"
export * from "./FolderThumbList.vue?vue&type=script&lang=js&"
import style0 from "./FolderThumbList.vue?vue&type=style&index=0&id=328f5a34&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328f5a34",
  null
  
)

export default component.exports